// Background subsection questionnaire constants
export enum BackgroundQuestionnaireItem {
  MEDICAL_BACKGROUND_BACKGROUND = 'medical-background/background',
  MEDICAL_BACKGROUND_BACKGROUND_PRIMARY_DIAGNOSIS = 'medical-background/background/primary-diagnosis',
  MEDICAL_BACKGROUND_BACKGROUND_OTHER_DIAGNOSIS = 'medical-background/background/other-diagnosis',
  MEDICAL_BACKGROUND_BACKGROUND_EQUIPMENT = 'medical-background/background/equipment',
  MEDICAL_BACKGROUND_BACKGROUND_EQUIPMENT_OTHER = 'medical-background/background/equipment-other',
  MEDICAL_BACKGROUND_BACKGROUND_DME_PROVIDER = 'medical-background/background/dme-provider',
  MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES = 'medical-background/background/allergies',
  MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES_NOTES = 'medical-background/background/allergies-notes',
  MEDICAL_BACKGROUND_BACKGROUND_WAIVERS = 'medical-background/background/waivers',
  MEDICAL_BACKGROUND_BACKGROUND_ADDITIONAL_SERVICES = 'medical-background/background/additional-services',
  MEDICAL_BACKGROUND_BACKGROUND_PROGNOSIS = 'medical-background/background/prognosis',
  MEDICAL_BACKGROUND_BACKGROUND_DNR = 'medical-background/background/dnr',
  MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES = 'medical-background/background/advance-directives',
  MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES_NOTES = 'medical-background/background/advance-directives-notes'
}
